import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router'; 
import { NgxSpinnerModule } from 'ngx-spinner';
import { TOAST_CONFIG, ToastrModule } from 'ngx-toastr';
import { AuthService } from './services/auth.service';
import { UserRole } from './core/enums/user-roles.enum';
// import { AuthService } from './services/auth.service';
// import { UserRole } from './core/enums/user-roles.enum';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    ToastrModule,
    RouterOutlet,
    NgxSpinnerModule, 
  ],
  providers: [ 
    {
      provide: TOAST_CONFIG,
      useValue: {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      },
    },
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'seleccion-personas';

  constructor(private authService: AuthService) {}

  ngOnInit(): void { 
    if (!this.authService.isAuthenticated()) { // cambiar después de implementar el login  
      this.authService.setUserRole(UserRole.CONSULTOR);
    } 
  }
}
